import { UserProfileI } from "@wind-log_library/fe-component-library";



interface UserProfileAttributesI {
  key?: string;
  value?: boolean | string;
}


export class MapUserProfile {
  constructor() {}

  public static mapData(data: any): any {
    const userData = data;
    const portfolioRights = userData?.attributes?.portfolio_rights || [];
    const portfolioRightsRaw = portfolioRights[0];
    const portfolioId = portfolioRightsRaw ? JSON.parse(portfolioRightsRaw)?.portfolio_id : undefined;
    const portfolioIds = portfolioRights
      .map(portfolioRight => JSON.parse(portfolioRight)?.portfolio_id)
      .filter((portfolioId): portfolioId is string => !!portfolioId) || [];

    return {
      id: userData.id,
      firstName: userData.firstName,
      lastName: userData.lastName,
      username: userData.username,
      email: userData.email,
      position: userData?.attributes?.position ? userData?.attributes?.position[0] : '-',
      appsAvailable: userData.apps_available,
      id_portfolio: portfolioId,
      portfolio_ids: portfolioIds,
      modulesAvailable: userData.modules_available,
      attributes: this.mapAttributes(userData.attributes),
      image: ''
    };
  }


  private static mapAttributes(attr): UserProfileAttributesI[]  {
    const attributes: UserProfileAttributesI[] = [];
    Object.keys(attr).filter(v => v !== '__typename').forEach(k => {
      attributes.push({key: k, value: attr[k]})
    })
    return attributes;
  }
}